import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-attr-shape-14",
  "use": "icon-attr-shape-14-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-attr-shape-14\"><path d=\"M14.835 27.226 5.155 7.127C4.69 6.161 5.328 5 6.32 5h19.36c.994 0 1.63 1.161 1.165 2.127l-9.68 20.099c-.494 1.032-1.834 1.032-2.33 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol